import ES from './es';
import EN from './en';

const recover = {
    ES,
    EN
};

export default recover;
